import secondaryComponents from "..";
import {
  defaultDateDisplay,
  formatCurrency,
  handleRenderStatusIndicator,
} from "../../../helpers";
import { useGetReturnsDetails } from "../../../hooks/api/queries/useOrder";
import { OrderItems } from "../StoreCheckout/TransactionDetailsV2/OrderItems";
import styles from "./styles.module.scss";
import primaryComponents from "../../primaryComponents";
import { CloseIcon, EditIcon } from "../../../assets/svgIcons";
import { useNavigate } from "react-router-dom";
import { pathConstants } from "../../../routes/pathContants";
import { useState } from "react";
import UpdateReturnDate from "./UpdateReturnDate";

const ReturnDetails = ({ closeModal = () => {}, orderId }) => {
  const { isLoading, data: orderDetails } = useGetReturnsDetails({
    id: orderId,
  });
  const store_currency = orderDetails?.store?.currency_code;
  const [isEditDate, setIsEditDate] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <div className="h-100">
        <primaryComponents.Button
          classNames={"ml-auto btn btn--outline smallBtn"}
          onClick={closeModal}
        >
          <CloseIcon style={{ fontSize: "16px" }} className="dark--text mr-1" />{" "}
          Close
        </primaryComponents.Button>
        <secondaryComponents.LoaderHelper
          classNames={"mt-5"}
          isLoading={isLoading}
        >
          <div className="d-flex flex-column" style={{ gap: "25px" }}>
            <div>
              <h5 className="mb-1">Return Details</h5>
              <div className={styles.transactionDetails__column}>
                <div>
                  <p className="d-flex align-item-center">
                    <secondaryComponents.NavigateWithPermission
                      permissionParentKey={"Inventory Management"}
                      permissionChildKey="can_update_returns_return_date"
                    >
                      <secondaryComponents.ToolTipV2 tipText="Edit Return Date">
                        <span
                          className="mr-1"
                          style={{ cursor: "pointer" }}
                          onClick={() => setIsEditDate(true)}
                        >
                          <EditIcon />
                        </span>
                      </secondaryComponents.ToolTipV2>
                    </secondaryComponents.NavigateWithPermission>
                    <p className="small-text-size mb-0">Return Date:</p>
                  </p>

                  <p className="dark--text">
                    {defaultDateDisplay(orderDetails?.return_date)}
                  </p>
                </div>

                <div>
                  <p className="small-text-size">Cashier:</p>
                  <p className="dark--text">
                    {orderDetails?.cashier?.first_name || "N/A"}
                  </p>
                </div>
                <div>
                  <p className="small-text-size">Store Name:</p>
                  <p className="dark--text">
                    {orderDetails?.store?.name || "N/A"}
                  </p>
                </div>
                <div>
                  <p className="small-text-size">Order Status:</p>
                  <span
                    style={{
                      ...handleRenderStatusIndicator(
                        orderDetails?.order?.status,
                      ),
                    }}
                    className="success--squared"
                  >
                    {orderDetails?.order?.status?.replace("_", " ")}
                  </span>
                </div>
                {/* <div>
                <p className="small-text-size">Return Order Status:</p>
                <span
                  style={{
                    ...handleRenderStatusIndicator(orderDetails?.status),
                  }}
                  className="success--squared"
                >
                  {orderDetails?.status?.replace("_", " ")}
                </span>
              </div> */}
                <div>
                  <p className="small-text-size">Order Number:</p>
                  <p
                    onClick={() => {
                      navigate(
                        pathConstants.INVENTORY_SALES_TRANSACTIONS +
                          `?orderId=${orderDetails?.order?.id}`,
                      );
                    }}
                    className="purple--text cursor-pointer"
                  >
                    {orderDetails?.order?.id || "N/A"}
                  </p>
                </div>

                <div>
                  <p className="small-text-size">Customer:</p>
                  {orderDetails?.order?.customer?.full_name ? (
                    <p
                      onClick={() => {
                        navigate(
                          pathConstants.CUSTOMER_DETAILS({
                            customerId: orderDetails?.order?.customer?.id,
                          }),
                        );
                      }}
                      className="purple--text cursor-pointer"
                      style={{ textDecoration: "underline" }}
                    >
                      {orderDetails?.order?.customer?.full_name}
                    </p>
                  ) : (
                    "N/A"
                  )}
                </div>

                <div>
                  <p className="small-text-size">Note:</p>
                  <p className="dark--text">{orderDetails?.remarks || "N/A"}</p>
                </div>

                {/* <div>
                <p className="small-text-size">Refund method:</p>
                <p className="dark--text">
                  {orderDetails?.payment_method || "N/A"}
                </p>
              </div> */}

                {orderDetails?.has_returned_items && (
                  <div>
                    <p className="small-text-size">Return Amount:</p>
                    <span className="dark--text">
                      {formatCurrency({
                        value: orderDetails?.total_returned_amount,
                        currencyCode: store_currency,
                      })}
                    </span>
                    <span
                      style={{
                        color: "#696677",
                        fontSize: "8px",
                        background: "#EFEFEF",
                        padding: "2px 5px",
                        borderRadius: "5px",
                        marginLeft: "10px",
                        width: "fit-content",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {orderDetails?.return_status
                        ? orderDetails?.return_status?.replace("_", " ")
                        : "N/A"}
                    </span>
                  </div>
                )}

                {Number(orderDetails?.total_returned_service_charge || 0) >
                  0 && (
                  <div>
                    <p className="small-text-size">Service Charge Refund:</p>
                    <p className="dark--text">
                      {formatCurrency({
                        value: orderDetails?.total_returned_service_charge,
                        currencyCode: store_currency,
                      })}
                    </p>
                  </div>
                )}

                {Number(orderDetails?.total_returned_delivery_fee || 0) > 0 && (
                  <div>
                    <p className="small-text-size">Delivery Fee Refund:</p>
                    <p className="dark--text">
                      {formatCurrency({
                        value: orderDetails?.total_returned_delivery_fee,
                        currencyCode: store_currency,
                      })}
                    </p>
                  </div>
                )}

                <div>
                  <p className="small-text-size">Refunded Amount:</p>
                  <p className="dark--text">
                    {formatCurrency({
                      value: orderDetails?.refundable_amount,
                      currencyCode: store_currency,
                    })}
                  </p>
                </div>
              </div>
            </div>

            <div>
              <h5 className="mb-1">Returned Items</h5>
              <OrderItems
                orderDetails={orderDetails}
                isViaTnx={false}
                type="RETURNED"
              />
            </div>
          </div>
        </secondaryComponents.LoaderHelper>
      </div>

      <secondaryComponents.Modal
        isActive={isEditDate}
        closeModal={() => setIsEditDate(false)}
        width={500}
      >
        <UpdateReturnDate
          returnId={orderDetails?.id}
          closeModal={() => setIsEditDate(false)}
        />
      </secondaryComponents.Modal>
    </>
  );
};
export default ReturnDetails;
